module.exports = __webpack_public_path__ + "media/images/landkit/icons/payment-methods/jcb-18c66f4ff0c435bf327e763050eb78d9.svg";